import { useState, createContext } from "react"




export const ThemeSiteContext = createContext()

export function ThemeSiteProvider(props) {

  const [themeSite, setThemeSite] = useState("dark")
 

  function handleToggleTheme() {
    setThemeSite(prevState => prevState === "dark" ? "light" : "dark")
  }

  return (
    <ThemeSiteContext.Provider value={{
      theme: {themeSite, handleToggleTheme},

    }}>

      {props.children}
    </ThemeSiteContext.Provider>


  )



}
